// Centralized body scroll lock utility to avoid conflicts across components
// Maintains a lock count so multiple overlays can coexist safely

let bodyScrollLockCount = 0;

export function lockBodyScroll(): void {
	bodyScrollLockCount += 1;
	if (typeof document !== 'undefined' && bodyScrollLockCount === 1) {
		document.body.classList.add('overflow-hidden');
	}
}

export function unlockBodyScroll(): void {
	if (bodyScrollLockCount > 0) {
		bodyScrollLockCount -= 1;
	}
	if (typeof document !== 'undefined' && bodyScrollLockCount === 0) {
		document.body.classList.remove('overflow-hidden');
	}
}

export function useBodyScrollLock(active: boolean): void {
	// Lightweight hook wrapper around the lock/unlock functions
	// Locks when active becomes true; unlocks when it becomes false or on unmount
	// This ensures proper pairing and avoids layout jumps.
	// eslint-disable-next-line react-hooks/rules-of-hooks
	require('react').useEffect(() => {
		if (active) {
			lockBodyScroll();
			return () => {
				unlockBodyScroll();
			};
		}
		return () => {};
	}, [active]);
}


